import { getDefaultFormValues } from "shared/Scan/helpers";
import { ScanFormFields } from "shared/Scan/types";

import { ScanSettingsItem } from "../gql";

export type ScanSettingsResourceScopeFormFields = Pick<ScanFormFields, "resourceTypes">;

export const getFormDefaultValues = (
  scanSettings: ScanSettingsItem
): ScanSettingsResourceScopeFormFields => {
  const { resourceTypes } = getDefaultFormValues(scanSettings);
  return { resourceTypes };
};
